// extracted by mini-css-extract-plugin
export default {"modal":"PhotoModal_modal__mCcHt","close":"PhotoModal_close__eqbF1","navigation":"PhotoModal_navigation__Kscvt","prev":"PhotoModal_prev__6VuGp","next":"PhotoModal_next__89MRp"};